import React from 'react';

export const PopupCloseIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.80001 0L0 1.80001L7.20009 9.00009L7.27464e-05 16.2001L1.80008 18.0001L9.00009 10.8001L16.2001 18.0001L18.0001 16.2001L10.8001 9.00009L18.0001 1.80006L16.2001 5.28563e-05L9.00009 7.20009L1.80001 0Z"
        fill="#1E2127"
      />
    </svg>
  );
};
